import React, { useState } from "react";
import { BankFeedAccount } from "../constants";
import { GenericBankFeedsInfoIcon } from "../GenericBankFeedsInfoIcon";
import { DropdownContents } from "./DropdownContents";
import { DropdownWrapper } from "./DropdownWrapper";

export const DropdownUnlinked = React.memo(
  ({
    bfAccount,
    setHoverId,
    shouldShowHover,
    shouldShowDropdown,
    setVisibleBfAccount,
    glAccountDropdownLabel,
    getSelectableGLAccountDropdownOptions,
  }: {
    bfAccount: BankFeedAccount;
    setHoverId: (id: string | null) => void;
    shouldShowHover: boolean;
    shouldShowDropdown: boolean;
    setVisibleBfAccount: (account: BankFeedAccount | null) => void;
    glAccountDropdownLabel: string;
    getSelectableGLAccountDropdownOptions: (
      bfAccount: BankFeedAccount,
      page: number,
      setPage: (page: number) => void,
    ) => JSX.Element;
  }) => {
    const [page, setPage] = useState(0);

    return (
      <DropdownWrapper visible={shouldShowDropdown}>
        <>
          <DropdownContents
            disabled={false}
            overlay={getSelectableGLAccountDropdownOptions(
              bfAccount,
              page,
              setPage,
            )}
            bfAccountId={bfAccount.id}
            onVisibleChange={(isVisible: boolean) => {
              setVisibleBfAccount(isVisible ? bfAccount : null);
            }}
            glAccountDropdownLabel={glAccountDropdownLabel}></DropdownContents>

          <GenericBankFeedsInfoIcon
            text="Select the GL account that these transactions belong to."
            hover={shouldShowHover}
            onMouseEnter={() => {
              setHoverId(bfAccount.id);
            }}
            onMouseLeave={() => {
              setHoverId(null);
            }}></GenericBankFeedsInfoIcon>
        </>
      </DropdownWrapper>
    );
  },
);
